import React from 'react';
import connectToI18n from 'modules/i18n/connectToI18n';
import PropTypes from 'prop-types';
import { Button } from 'components/ui';
import PaymentProfileCompletionContainer from 'components/PaymentProfileCompletion/PaymentProfileCompletionContainer.jsx';
import { connect } from 'react-redux';
import { redirectToPaymentPage, unlockForms } from 'modules/giftCard';
import Backbone from 'backbone';
import { userSelector } from 'modules/currentUser';

export class BuyGiftCardKyc extends React.Component {
    static propTypes = {
        unlockForms: PropTypes.func.isRequired,
        trans: PropTypes.func.isRequired,
        user: PropTypes.object.isRequired,
        redirectToPaymentPage: PropTypes.func.isRequired,
    };

    onBack = () => {
        this.props.unlockForms();
        Backbone.history.navigate('giftcards', { trigger: true });
    };

    onCompletion = () => {
        this.props.redirectToPaymentPage();
    };

    renderBackLink = () => {
        const trans = this.props.trans;

        return (
            <Button icon="angle-left" weight="link" onClick={this.onBack}>
                {trans('global.back')}
            </Button>
        );
    };

    render() {
        return (
            <div className="buyGiftCardMainContent buyGiftCardKyc">
                <PaymentProfileCompletionContainer
                    {...this.props}
                    backLink={this.renderBackLink()}
                    onCompletion={this.onCompletion}
                    user={this.props.user}
                />
            </div>
        );
    }
}

export default connect(
    state => ({
        user: userSelector(state),
    }),
    {
        redirectToPaymentPage,
        unlockForms,
    }
)(connectToI18n(BuyGiftCardKyc));
